import { type ReactElement } from 'react'
import whatsAppLogo from './assets/WhatsApp_btn.png'
import * as S from './whats-app-link-button.styled'

export function WhatsAppLinkButton (): ReactElement {
  return <S.LinkButton rel="noopener noreferrer" target="_blank" to="https://wa.me/551140039710">
    <img src={whatsAppLogo} alt="Logo do WhatsApp" />
  </S.LinkButton>
}
